import { object, string, null as zNull, type infer as zInfer } from "zod/v4";

export const setLuminousIntegration = {
  name: "setLuminousIntegration" as const,
  input: object({
    accessToken: string(),
    apiDomain: string(),
    restockSetting: object({ locationId: string(), warehouseId: string() }),
  }),
  output: zNull(),
};

export type SetLuminousIntegrationInput = zInfer<
  typeof setLuminousIntegration.input
>;
